import React from 'react'
import {useNavigate } from 'react-router-dom'
import { Typography, Image, Table, Tag } from 'antd';
import roadtypeImg from "../lineroad/roadtype.jpg"
import manuImg from "../lineroad/menu2.jpg"
const { Title, Paragraph, Link } = Typography;

export default function Specialroad() {
  const dataSource = [
    {
      key: '1',
      name: '平曲线半径',
      range: '30~5000',
      desc: '平曲线部分的圆曲线半径。',
    },
    {
      key: '2',
      name: '平曲线转角',
      range: '-60~60',
      desc: '平曲线偏角。',
    },
    {
      key: '3',
      name: '公交站台长度',
      range: '0~50',
      desc: '公交站台长度，不含前后过渡段。',
    },
    {
      key: '4',
      name: '公交站台过渡长度',
      range: '0~20',
      desc: '公交站台前后过渡段长。',
    },
    {
      key: '5',
      name: '中央分隔带开口宽',
      range: '0~20',
      desc: '中央分隔带上的机动车开口宽度，最窄处宽度。用于横断面为二幅路、四幅路。',
    },
    {
      key: '6',
      name: '中央分隔带开口距离',
      range: '0~500',
      desc: '中央分隔带上的机动车开口距道路起点的距离。用于横断面为二幅路、四幅路。',
    },
    {
      key: '7',
      name: '左分隔带开口宽',
      range: '0~20',
      desc: '左边侧分隔带上的机动车开口宽度，最窄处宽度。用于横断面为三幅路、四幅路。',
    },
    {
      key: '8',
      name: '左分隔带开口距离',
      range: '0~500',
      desc: '左边侧分隔带上的机动车开口距道路起点的距离。用于横断面为三幅路、四幅路。',
    },
    {
      key: '9',
      name: '右分隔带开口宽',
      range: '0~20',
      desc: '右边侧分隔带上的机动车开口宽度，最窄处宽度。用于横断面为三幅路、四幅路。',
    },
    {
      key: '10',
      name: '右分隔带开口距离',
      range: '0~500',
      desc: '右边侧分隔带上的机动车开口距道路起点的距离。用于横断面为三幅路、四幅路。',
    }
  ];

  const columns = [
    {
      title: '参数',
      dataIndex: 'name',
      render: (name)=>{
        return (
          <Tag color={'volcano'} key={name}>
            {name}
          </Tag>
        );
      }
    },
    {
      title: '取值范围',
      dataIndex: 'range',
      key: 'range',
    },
    {
      title: '描述',
      dataIndex: 'desc',
      key: 'desc',
    },
  ];
  const navigate = useNavigate ();
  return (
    <Typography>
      <Title level={2}>介绍</Title>
      <Paragraph>
        本软件提供三种道路效果图场景，分别为直线路段、十字交叉口和特殊路段，特殊路段场景提供一段具有平曲线、港湾式公交站台、以及分隔带上机动车和人行道开口的特殊道路模型。在该场景中，
        通过修改道路横断面、曲线半径和转角、公交站位置尺寸等参数来修改道路模型。可以通过以下两种方式进入特殊路段场景：
      </Paragraph>
      <Paragraph>
        <ul>
          <li>
            通过启动菜单<br></br>
            <Image width={100} src={manuImg} />
          </li>
          <li>
            通过主界面上方区域的道路类型下拉列表框<br></br>
            <Image width={200} src={roadtypeImg} />
          </li>
        </ul>
      </Paragraph>
      <Title level={2}>道路横断面参数</Title>
      <Paragraph>
      <Link onClick={()=>{navigate("/content/roadmodel/lineroad")}}>见直线路段</Link>
      </Paragraph>
      <Title level={2}>曲线控制参数</Title>
      <Paragraph>
      <Table dataSource={dataSource} columns={columns} pagination={{pageSize:50}}/>;
      </Paragraph>
    </Typography>
  )
}
